import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ColumnFilter from '../column-filter';
import Divider from '@material-ui/core/Divider';
import Typography from 'fuse-ui/components/Typography';
import { TABLE_HEADER_HEIGHT } from  '../constants/table-options';

const styles = ( theme ) => {
    return {
        headerDivider: {
            margin: '4px -24px 0 -24px',
        },
        noData: {
            position: 'absolute'
        },
        noOutline: {
            '&:focus': {
                outline: 'none'
            },
            outline: 'none',
        },
        tableHeader: {
            alignItems: 'baseline',
            display: 'flex',
            height: TABLE_HEADER_HEIGHT,
            justifyContent: 'space-between',
        },
        tableTotalCount: {
            paddingBottom: theme.spacing.unit
        },
    };
};

const ColumnFilterHeader = ( {
    classes, columnDefs, description, dataAutomationId, onColumnReset, onColumnToggle, persistColumnFilters
} ) => {
    return (
        <React.Fragment>
            <div className={classes.tableHeader}>
                <Typography
                    classes={{ root: classes.tableTotalCount }}
                    data-automation-id={`${dataAutomationId}-grid-data-count`}
                    inline={true}
                    variant="subtitle1"
                >
                    {description}
                </Typography>
                <ColumnFilter
                    columnHeaders={columnDefs}
                    data-automation-id={`${dataAutomationId}-grid-column-filter`}
                    onColumnToggle={onColumnToggle}
                    onColumnReset={onColumnReset}
                    persistColumnFilters={persistColumnFilters}
                />
            </div>
            <Divider className={classes.headerDivider} />
        </React.Fragment>
    );
};

ColumnFilterHeader.propTypes = {
    classes: PropTypes.object,
    columnDefs: PropTypes.array.isRequired,
    dataAutomationId: PropTypes.string.isRequired,
    description: PropTypes.string,
    onColumnReset: PropTypes.func,
    onColumnToggle: PropTypes.func,
    persistColumnFilters: PropTypes.array,
};

ColumnFilterHeader.defaultProps = {
    description: ''
};

export default withStyles( styles )( ColumnFilterHeader );
